import type { IApiClient } from '../api/IApiClient'

export interface SessionIdentity {
  isAdmin: boolean
  email: string
}

/**
 * Who is signed in. `/api/admin/check` only returns the email to admins (403 for the
 * user role), so fall back to `/auth/session` when it yields none — same order as
 * Layout.tsx. Never rejects: an unresolvable session is `{ isAdmin: false, email: '' }`,
 * which owner-only gates (e.g. rename) treat as "not the owner".
 */
export async function resolveSessionIdentity(
  api: Pick<IApiClient, 'checkAdminAccess' | 'getSessionEmail'>,
): Promise<SessionIdentity> {
  let isAdmin = false
  try {
    const res = await api.checkAdminAccess()
    isAdmin = res.isAdmin
    if (res.email) return { isAdmin, email: res.email }
  } catch {
    // Fall through to the session probe.
  }
  try {
    return { isAdmin, email: (await api.getSessionEmail()) || '' }
  } catch {
    return { isAdmin, email: '' }
  }
}
